import { FC } from 'react';
import { NamePath } from '~/utils/buildNamePath';
import { DirectionProp } from '~/types/Direction';
import styled from 'styled-components';
import { useDirection } from '~/hooks/i18nHooks';
import { useTranslation } from 'react-i18next';
import { PlusIcon } from '~/img';
import { Button } from '~/components';
import { useGetApplication } from '~/controllers/wizard';
import { isReadOnly } from '~/utils/isReadOnly';
import ManualScreeningResultsForm from './ManualScreeningResultForm';

interface Props {
  baseNamePath: NamePath;
  withCancel?: boolean;
  isFormVisible: boolean;
  onFormVisible: (visible: boolean) => void;
  disabled?: boolean;
}

const ManualScreeningAction: FC<Props> = ({
  withCancel = false,
  baseNamePath,
  isFormVisible,
  onFormVisible,
  disabled,
}: Props) => {
  const dir = useDirection();
  const [t] = useTranslation('ksaReview');

  const onCancelClick = (e: any) => {
    onFormVisible(false);
    e.stopPropagation();
    e.preventDefault();
    return false;
  };

  const onAddClick = () => {
    onFormVisible(true);
  };

  const applicationQuery = useGetApplication();
  const readOnly = isReadOnly(applicationQuery.data);

  return withCancel ? (
    isFormVisible ? (
      <Container dir={dir}>
        <ManualScreeningResultsForm baseNamePath={baseNamePath} />
        <Button
          className="FormDrawer-Close"
          danger
          onClick={onCancelClick}
          type="default"
          id="closeManualScreening"
          style={buttonStyles}
        >
          {t('Cancel')}
        </Button>
      </Container>
    ) : (
      <Button
        id="addManualScreening"
        extraLarge
        icon={<PlusIcon />}
        onClick={onAddClick}
        disabled={readOnly || disabled}
      >
        {t('Add manual screening')}
      </Button>
    )
  ) : (
    <ManualScreeningResultsForm baseNamePath={baseNamePath} />
  );
};

const Container = styled.div<DirectionProp>``;

const buttonStyles = { border: 'none', boxShadow: 'none', padding: 0 };

export default ManualScreeningAction;
